import React from 'react';
import { RiDeleteBin5Line } from 'react-icons/ri';

import './style.scss';

type AddedBankAccuntDetailsProps = {
  values: AddedBankAccuntDetailsValues;
  onDelete: () => void;
};

type AddedBankAccuntDetailsValues = {
  accountNumber: string;
  accountHolderName: string;
  routingNumber: string;
};

const AddedBankAccuntDetails: React.FunctionComponent<AddedBankAccuntDetailsProps> = ({ values, onDelete }) => {
  return (
    <div className="position-relative font-size-14 border rounded p-3 w-50">
      <span className="position-absolute delete-bank-account-icon c-pointer" onClick={onDelete}>
        <RiDeleteBin5Line size={18} />
      </span>
      <div className="mb-2">
        <div id="accountNumber">Account Number</div>
        <div>{values.accountNumber}</div>
      </div>
      <div className="mb-2">
        <div id="accountHolderName">Account Holder Name</div>
        <div>{values.accountHolderName}</div>
      </div>
      <div>
        <div id="routingNumber">Routing Number</div>
        <div>{values.routingNumber}</div>
      </div>
    </div>
  );
};

export default AddedBankAccuntDetails;
